import React from 'react';
import { cn } from '../../utils/cn';

const SegmentedControl = ({ value, onChange, options, ariaLabel, className }) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={cn(
      'inline-flex items-stretch rounded-xl border border-border bg-muted/60 p-1',
      className,
    )}
  >
    {options.map((option) => {
      const isActive = option.value === value;

      return (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(option.value)}
          className={cn(
            'inline-flex min-w-0 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 font-caption text-xs font-semibold transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            isActive
              ? 'bg-card text-primary shadow-sm'
              : 'text-muted-foreground hover:bg-card/50 hover:text-foreground',
          )}
        >
          <span>{option.label}</span>
          {option.badge > 0 && (
            <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-error px-1.5 text-[10px] font-caption font-medium text-white">
              {option.badge > 99 ? '99+' : option.badge}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
